import { render, staticRenderFns } from "./_googleSearch.vue?vue&type=template&id=0d924078&lang=pug&"
import script from "./_googleSearch.vue?vue&type=script&lang=js&"
export * from "./_googleSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports